import { useState } from 'react';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';

import { SetEndCountdownChip } from '../SetEndCountdownChip/index.tsx';
import { SetWillEndDialog } from '../SetWillEndDialog/index.tsx';

type Props = { endDate: Date };
export const SeriesBoardTimer = ({ endDate }: Props) => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <ButtonBase
        onClick={() => {
          setShowDialog(true);
        }}
      >
        <SetEndCountdownChip endDate={endDate} />
      </ButtonBase>
      <SetWillEndDialog
        open={!!showDialog}
        onClose={() => {
          setShowDialog(false);
        }}
        endDate={endDate}
      />
    </>
  );
};
